import { render, staticRenderFns } from "./edit-wood-info.vue?vue&type=template&id=964dd690&scoped=true&"
import script from "./edit-wood-info.vue?vue&type=script&lang=ts&"
export * from "./edit-wood-info.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "964dd690",
  null
  
)

export default component.exports